









































// vue
import {
    computed,
    defineComponent,
    onMounted,
    ref,
} from '@vue/composition-api';

// hooks
import { useBlueprintHook } from '@/vue3/hooks/blueprintHook';

// components
import EditorText from '@/vue3/components/editor/EditorText.vue';

export default defineComponent({
    props: {
        geoRecords: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Object,
            default: null,
        },
    },
    components: {
        EditorText,
    },
    setup(props: any, { emit }) {
        // hooks
        const { drawGrid, createSvg } = useBlueprintHook();

        // reactive
        const searchInput = ref('');
        const geomHtml = ref<any[]>([]);

        // computed
        const filteredData = computed(() => {
            const filtered: object[] = geomHtml.value.filter((i: any) => {
                const title = i.geoRecord.title.toUpperCase();
                const searchQueryUppercase = searchInput.value.toUpperCase();
                return title.indexOf(searchQueryUppercase) !== -1;
            });
            return filtered;
        });

        // lifecycle
        onMounted(() => {
            const geomData: any[] = [];
            props.geoRecords.forEach((x: any) => {
                if (x.geometry.type === 'Polygon') {
                    const blueprintSize = 120;
                    const svg = createSvg(
                        {
                            type: 'Feature',
                            geometry: x.geometry,
                        },
                        {
                            strokeWidth: 1.5,
                            stroke: 'white',
                            width: blueprintSize,
                            height: blueprintSize,
                            padding: blueprintSize / 10,
                            color: '#3057e1',
                        },
                    );
                    if (svg) {
                        drawGrid(blueprintSize, blueprintSize, 1, svg);
                        geomData.push({ html: svg.outerHTML, geoRecord: x });
                    }
                }
            });
            geomHtml.value = geomData;
        });

        // methods
        const selectGeoRecord = (record: any) => {
            emit('input', record.geometry);
        };

        return {
            geomHtml,
            searchInput,
            filteredData,
            selectGeoRecord,
        };
    },
});
